export default __webpack_public_path__ + "static/media/Avatar_3.7107bd8c.png";